<template>
  <!--  
      Usage: 
      
      this.$store.commit('setFeedbackSnack', { 
        msg: '', 
        color:'',
        x: '',         
        y: '',         
      })
      
      // x = string ('left', 'right')
      // y = string ('bottom', 'top')
      // msg = string
      // color = string ('success', 'warning', 'error', 'info')
  -->
  <v-snackbar
    v-model="snackbar"
    :color="feedback.color"
    :bottom="feedback.y === 'bottom'"
    :left="feedback.x === 'left'"
    :right="feedback.x === 'right'"
    :top="feedback.y === 'top'"
  >
    {{ feedback.msg }}
    <v-btn text @click="snackbar = false">{{ $t("close") }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "feedbackSnack",
  data: () => ({
    snackbar: false,
  }),
  computed: {
    feedback() {
      return this.$store.state.feedbackSnack;
    },
  },
  watch: {
    feedback() {
      this.snackbar = true;
    },
  },
};
</script>
